import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { Text } from '../../../../components/presentation/Text'
import { formatDate } from '../../../../utils/helpers/date'
import { segmentsClient } from '../../../../utils/apollo/api'
import { useOpenSegmentModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useRowsActions } from './_actions/rowsActions'
import { useSegments } from '../_load/SegmentsLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'

const SegmentationsTable = () => {
  const { t } = useTranslation(['common', 'listSegmentations'])
  const data = useSegments()
  const openDetailsModal = useOpenSegmentModal()

  const columns = [
    {
      label: t('listSegmentations:table.name'),
      dataIndex: 'name',
      sortIndex: 'NAME',
      headerSideContent: (
        <>
          <ListCounter client={segmentsClient} entity="segments" filterName="SegmentFilter" />
          <RefetchingIndicator />
        </>
      ),
      flex: 3,
      render: (value, record) => (
        <Link onClick={() => openDetailsModal(record)} block>
          <Text strong color={COLORS.dark2} breakWord>
            {capitalizeAllIfLower(value)}
          </Text>
        </Link>
      )
    },
    {
      label: t('listSegmentations:table.createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },
    {
      label: t('listSegmentations:table.updatedAt'),
      dataIndex: 'updatedAt',
      sortIndex: 'UPDATED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },
    {
      label: t('common:actions'),
      flex: 1,
      render: useRowActionsColumn(useRowsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default SegmentationsTable
